import { Pipe, PipeTransform } from '@angular/core';
import { GridItem, GridCommand } from '../grid-control.model';
@Pipe({
  name: 'commandHidden'
})
export class CommandHidden implements PipeTransform {
  async transform(item: GridItem, command: GridCommand): Promise<boolean> {
    const { hidden, hiddenByItem } = command;
    if (hidden) {
      return true;
    }
    if (hiddenByItem) {
      const hiddenResult = hiddenByItem(item);
      if (hiddenResult instanceof Promise) {
        if (await hiddenResult) {
          return true;
        }
      } else {
        if (hiddenResult) {
          return true;
        }
      }
    }
    if ('children' in command) {
      const results = [];
      for (const childCommand of command.children) {
        const { hidden: childHidden, hiddenByItem: childHiddenByItem } = childCommand;
        if (!childHidden && !childHiddenByItem) {
          results.push(childCommand);
        } else {
          if (childHiddenByItem) {
            const hiddenResult = childHiddenByItem(item);
            if (hiddenResult instanceof Promise) {
              if (!await hiddenResult) {
                results.push(childCommand);
              }
            } else {
              if (!hiddenResult) {
                results.push(childCommand);
              }
            }
          }
        }
      }
      if (results.length === 0) {
        return true;
      }
    }
    return false;
  }
}
